<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    body:after {
        background-image: url('../imgs/business/zyyw_bg.jpg'); background-repeat: no-repeat; background-size: cover;
    }

    /*
     * pan_height_line1
     */

    .pan_height_line1_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_zh {
            height: 360px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_zh {
            height: 340px;
            /*height: 315px;*/
        }
    }

    .pan_height_line1_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_en {
            height: 360px;
            /*height: 415px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_en {
            height: 340px;
            /*height: 370px;*/
        }
    }

    /*
     * pan_height_line2
     */

    .pan_height_line2_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 294px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 306px;*/
        }
    }

    .pan_height_line2_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 346px;*/
        }
    }

    .container-margin-bottom {
        margin-bottom: 10px;
    }
    @media (min-width: 768px) {
        .container-margin-bottom {
            margin-bottom: 60px;
        }
    }

    .pan-num {
        text-align: center;
        font-size: 80px;
        /*color: #F29700;*/
        color: #D3A571;
        padding-left: 20px;
        padding-top: 25px;
    }
    @media (min-width: 768px) {
        .pan-num {
            font-size: 144px;
            padding-top: 0;
        }
    }

    .pan-num-size {
        width: 80px;
    }

    @media (min-width: 768px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 992px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 1200px) {
        .pan-num-size {
            width: 150px;
        }
    }

    .pan-01-wrapper {
        padding: 0px 0px 30px 0px;
    }

    @media (min-width: 768px) {
        .pan-01-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    @media (min-width: 1200px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    .pan-01 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_01_bg.png");
        background-position-x: right;
        background-position-y: top;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-01 {
            background-size: 15% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-01 {
            background-size: 30% auto;
        }
    }

    .pan-01b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-01b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-01b-size {
            width: 70%;
        }
    }

    .pan-01-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-01-detail-size {
            width: 85%;
        }
    }
    @media (min-width: 992px) {
        .pan-01-detail-size {
            width: 70%;
        }
    }

    .pan-02-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-02 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_02_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-02 {
            background-size: 20% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-02 {
            background-size: 28%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02 {
            background-size: auto;
        }
    }


    .pan-02b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-02b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02b-size {
            width: 65%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02b-size {
            width: 60%;
        }
    }

    .pan-02-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-02-detail-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02-detail-size {
            width: 68%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02-detail-size {
            width: 65%;
        }
    }

    /*
    ***************     pan-03
    */


    .pan-03-wrapper {
        padding: 0px 0px 30px 0px;
    }
    @media (min-width: 768px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }

    @media (min-width: 1200px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }



    .pan-03 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_03_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 25% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-03 {
            background-size: 28% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-03 {
            background-size: 31% auto;
        }
    }
    @media (min-width: 1200px) {
        .pan-03 {
            background-size: 33% auto;
        }
    }


    .pan-03b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 992px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03b-size {
            width: 80%;
        }
    }

    .pan-03-detail-size {
        width: 80%;
    }
    @media (min-width: 768px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 992px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03-detail-size {
            width: 65%;
        }
    }

    .pan-04-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-04 {
        background: RGBA(0,0,0,0.5);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }
    .list-style{ display: flex; flex-wrap: wrap; align-items: center; padding: 10px 20px 20px 20px; margin: 0 0 20px 0; background-color: #fff; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);}
    @media (min-width: 992px) {
        .list-style{margin: 0 20px 20px 20px;}
    }
    .list-style .text_jj{ padding: 10px 0 10px 0; font-size: 16px; color: #666; text-align: justify;}
    .list-style .text_a{ display: inline-block; margin: 0; padding: 0;}
    .list-style .text_a a{ display: inline-block; padding: 4px 10px; margin-top: 10px; background-color: rgba(255, 192, 0, 1); color: #222; font-size: 16px; line-height: normal;}
    .video_xj{ display: block; width: 100%; margin-top: 20px;}
    .info-style h4{ display: block; margin-bottom: 0; font-weight: bold; font-size: 24px; color: #f29603;}
</style>

<template>
    <div class="container container-margin-bottom">
        <div class="tx-page-title">
            {{ $t("biz_title") }} - <span>商业IP</span>
        </div>
        <div class="tx-page-subtitle">专注于街区式商业物业投资与运营</div>
        <!--商业IP-->
        <div class="list-style">
            <!--图片-->
            <div class="col-xs-12 col-sm-4" style="padding: 0;">
                <a href="projects.html" target="_blank"><img src="imgs/business/zyyw_ip2.png" style="width: 100%;"></a>
            </div>

            <div class="col-xs-12 col-sm-8 info-style">
                <h4>专注商街，共生烟火</h4>
                <!--简介-->
                <div class="col-xs-12 text_jj">专注于特色商业街区，一般规模在2-3万㎡，通过前期策划、工程改造，品牌导入，运营推广等方式，创造风格鲜明的主题场景，打造以“交往”与“我们”为内涵的体验式商街。与商家共成长，与社区共呼吸，与业主共未来。</div>

                <!--链接-->
                <div class="col-xs-12 text_a">
                    <a href="projects.html" target="_blank">了解更多</a>
                </div>
            </div>
            <video class="video_xj" width="100%" controls="controls" preload="none" poster="imgs/business/gbwh_mp4bg.jpg">
                <source src="imgs/business/gbwh_mp4.mp4" type="video/mp4">
                很抱歉，您的浏览器不支持观看此视频。
            </video>
        </div>
        <div class="list-style" style="margin-bottom: 80px;">
            <img src="imgs/business/gbwh1.jpg" style="width: 100%; margin-top: 10px;">
        </div>
    </div>
</template>
<script>

    module.exports = {
        computed: {
            pan_height_line1: function () {
                return {
                    pan_height_line1_zh: this.$i18n.locale != 'en_US',
                    pan_height_line1_en: this.$i18n.locale == 'en_US',
                }
            },
            pan_height_line2: function () {
                return {
                    pan_height_line2_zh: this.$i18n.locale != 'en_US',
                    pan_height_line2_en: this.$i18n.locale == 'en_US',
                }
            }
        },
        mounted: function () {

            $('#fundCert').viewer({
                scalable: false,
                navbar: false,
                title: false,
                toolbar: false,
                url: 'data-original'
            });
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_business,
                zh_HK: this.$i18n.messages.zh_HK.page_title_business,
                zh_CN: this.$i18n.messages.zh_CN.page_title_business
            };
            window.setTitle(window.pageTitle[this.$i18n.locale]);
        }

    };

</script>


// WEBPACK FOOTER //
// business_two.vue?12ebbd22